import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import CustomButton from '../../shared/CustomButton';

const useStyles = makeStyles({
  stickyFooter: {
    position: 'absolute',
    bottom: 0,
    background: 'white',
    padding: '10px',
    zIndex: 10,
  },
});

const PopupFooter = ({ cancelBtn, save, add }) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justifyContent="flex-end"
      alignItems="center"
      className={classes.stickyFooter}
      style={{ padding: '10px' }}
    >
      <Grid item>
        <CustomButton label="Cancel" variant="contained" size="small" type="secondary" onClick={cancelBtn} />
      </Grid>
      <Grid item style={{ marginLeft: '10px' }}>
        <CustomButton label={add ? 'Save' : 'Update'} variant="contained" size="small" type="primary" onClick={save} />
      </Grid>
    </Grid>
  );
};

export default PopupFooter;
